module.exports = __webpack_public_path__ + "img/full0-min.cb3c368b.png";